import { Button, Select, MenuItem, TextField, FormControl, InputLabel } from '@mui/material'
import { TaskStatus } from 'interfaces/entities/task.model'
import React from 'react'
import { Controller, FormProvider, useForm } from 'react-hook-form'
import { useGetMembers } from 'hooks/useGetMembers'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { toDate, toNativeDate } from 'helpers/dateHelper'
import { useGetPipelines } from 'hooks/useGetPipelines'

interface TaskFormProps {
    onSubmit: (task: any) => void,
    task: any
    leadID: string
    pipelines: any[]
}

const LeadTaskForm = ({ onSubmit, task, leadID, pipelines }: TaskFormProps) => {
    const { register, handleSubmit, setValue, control, getValues, watch, formState: { isValid, errors } } = useForm({
        defaultValues: task ? {
            id: task.id,
            title: task.title || '',
            description: task.description,
            dueDate: task.dueDate ? toNativeDate(task.dueDate) : toNativeDate(new Date()),
            assigneeID: task.assigneeID,
            status: task.status || TaskStatus.TODO,
            leadID: leadID,
            pipelineID: task.pipelineID
        } : {
            title: '',
            description: '',
            dueDate: toNativeDate(new Date()),
            assigneeID: '',
            status: TaskStatus.TODO,
            leadID: leadID,
            pipelineID: pipelines?.length > 0 ? pipelines[0].id : ''
        },
        mode: 'onChange',
    })

    const { t } = useTranslation()

    const { data: membersResponse } = useGetMembers(localStorage.getItem('orgID') || '')

    const onSubmitHook = (data: any) => {
        console.log('data: ', data)
        onSubmit(data)
    }
    return (
        <div className='flex flex-col gap-4 w-full mt-4'>
            <Controller control={control} name="pipelineID" render={({ field }) => (
                <FormControl fullWidth>
                    <InputLabel>Доска</InputLabel>
                    <Select label="Доска" fullWidth {...field}>
                        {pipelines.map((pipeline: any) => (
                            <MenuItem key={pipeline.id} value={pipeline.id}>{pipeline.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )} />
            <TextField label="Название задачи" fullWidth {...register('title')} />
            <TextField multiline rows={4} label="Описание задачи" fullWidth {...register('description')} />
            <TextField label="Дата выполнения" type="date" fullWidth {...register('dueDate')} InputLabelProps={{ shrink: true }} />
            <Controller control={control} name="assigneeID" render={({ field }) => (
                <FormControl fullWidth>
                    <InputLabel>Ответственный</InputLabel>
                    <Select label="Ответственный" fullWidth {...field}>
                        {membersResponse?.data?.map((member: any) => (
                            <MenuItem key={member.id} value={member.id}>{member.name || member.userID}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )} />
            <Controller
                control={control}
                name="status"
                render={({ field }) => (
                    <FormControl fullWidth>
                        <InputLabel>Статус задачи</InputLabel>
                        <Select label="Статус задачи" fullWidth {...field}>
                            {Object.values(TaskStatus).map((status) => (
                                <MenuItem key={status} value={status}>{t(`task.status.${status}`)}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
            />
            <Button variant="contained" color="primary" onClick={handleSubmit(onSubmitHook)} disabled={!isValid}>Добавить задачу</Button>
        </div>
    )
}


interface LeadTaskFormWrapperProps {
    onSubmit: (task: any) => void,
    task: any
    leadID: string
}

export default function LeadTaskFormWrapper({ onSubmit, task, leadID }: LeadTaskFormWrapperProps) {
    const { data: pipelines } = useGetPipelines(localStorage.getItem('orgID') || '', 'tasks')
    if (!pipelines) {
        return <div>Loading...</div>
    }
    return <LeadTaskForm onSubmit={onSubmit} task={task} leadID={leadID} pipelines={pipelines} />
}